// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lite-label[data-v-5b74fddc]{color:#b44eda!important;color:rgba(180,78,218,var(--tw-text-opacity))!important}.core-label[data-v-5b74fddc],.lite-label[data-v-5b74fddc]{--tw-text-opacity:1!important}.core-label[data-v-5b74fddc]{color:#3d1266!important;color:rgba(61,18,102,var(--tw-text-opacity))!important}.elite-label[data-v-5b74fddc]{--tw-text-opacity:1!important;color:#ff484b!important;color:rgba(255,72,75,var(--tw-text-opacity))!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
